import React from 'react';

import Link from 'buyside/components/presentation/Link/link';

import { jobPostingUrl } from 'buyside/util/urlHelper';

import styles from './toasterStyles.scss';

const JobApplicationToaster: React.FC<{ count: number }> = ({ count }) => {
  return (
    <>
      <span>
        You currently have{' '}
        <strong>
          {count} new application{count > 1 ? 's' : ''}{' '}
        </strong>
        for your posted positions.{' '}
      </span>
      <div className={styles.actions}>
        <Link to={jobPostingUrl()}>View Applications</Link>
      </div>
    </>
  );
};

export default JobApplicationToaster;
